import React from "react";
import Navigation from "../components/Navigation";
import Logo from "../assets/images/logo.png";
import { FosterLogin } from "../http/server-apis.js";
import { MuiOtpInput } from "mui-one-time-password-input";
import { FaChevronRight, FaExclamationTriangle } from "react-icons/fa";
import { useTranslation } from "react-i18next";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";

import { userAction } from "../store/languageSlice";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";

function LogIn() {
  const { t } = useTranslation();
  const [number, setNumber] = React.useState("");
  const [pin, setPin] = React.useState("");

  const [openModal, setOpenModal] = React.useState(false);
  const [modalText, setModalText] = React.useState("");

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleNumberChange = (newValue) => {
    setNumber(newValue);
  };
  const handlePinChange = (newValue) => {
    setPin(newValue);
  };
  const handleSumbit = async () => {
    if (number.length === 0) {
      setOpenModal(true);
      setModalText("Enter shining stars number first");
      return;
    }
    if (pin.length === 0) {
      setOpenModal(true);
      setModalText("Enter pin number first");
      return;
    }
    try {
      const response = await FosterLogin("post", {
        data: {
          StarsNumber: number,
          PIN: pin,
        },
      });

      if (response.data.Status === "failure") {
        setOpenModal(true);
        setModalText(response.data.Message);
        return;
      }
      if (response.data.Status === "success") {
        dispatch(userAction(response.data.StarsNumber));
        navigate("/mood");
      }
    } catch (error) {
      //Open Alert Modal
      setOpenModal(true);
      setModalText("Something Went Wrong");
    }
  };
  function onForgotNumber() {
    navigate("/forgot_number");
  }
  function onForgotPin() {
    navigate("/forgot_pin");
  }
  function onRegisterDelete() {
    navigate("/register_delete");
  }

  return (
    <>
      <Navigation title={"LOGIN"} appBarColor="orange" />

      <div className="fixed-layout flex flex-col">
        <div className="language-card my-2 flex-1 flex items-center">
          <div className="w-10/12 mx-auto">
            <img src={Logo} alt="language" className=" w-[70%] mx-auto my-5" />
            <div className="mt-10">
              <p className="text-sm md:text-lg lg:text-lg md:font-normal text-primary font-semibold pb-4">
                {t("SHINING_STARS_NUMBER")}
              </p>
              <MuiOtpInput
                value={number}
                onChange={handleNumberChange}
                variant="standard"
              />
              <p
                className="text-right text-xs md:text-sm lg:text-base md:font-normal text-secondary font-light mt-1"
                onClick={onForgotNumber}
              >
                {t("FORGOT_NUMBER")}
              </p>
            </div>

            <div className="mt-5">
              <p className="text-sm md:text-lg lg:text-lg md:font-normal text-primary font-semibold pb-4">
                {t("PIN")}
              </p>
              <MuiOtpInput
                value={pin}
                onChange={handlePinChange}
                variant="standard"
              />
              <p
                className="text-right text-xs md:text-sm lg:text-base md:font-normal text-secondary font-light mt-1"
                onClick={onForgotPin}
              >
                {t("FORGOT_PIN")}
              </p>
            </div>

            <div className="flex flex-col items-center justify-center mt-3 md:mt-8">
              <button
                onClick={handleSumbit}
                className="bg-primary  w-[45%] flex items-center justify-center uppercase text-sm lg:text-lg font-normal tracking-[1px] mb-1 px-12 text-white py-2 shadow shadow-slate-400 rounded-sm"
              >
                {t("SUBMIT")}
              </button>
              <p
                href=""
                className="text-center text-xs md:text-sm lg:text-base md:font-normal text-secondary font-light mt-1 flex items-center"
                onClick={onRegisterDelete}
              >
                {t("REGISTER")}
                <FaChevronRight />
              </p>
              <Link
                to="/privacy_policy"
                className="text-center text-xs md:text-sm lg:text-base  text-secondary font-light mt-1 flex items-center"
              >
                {t("PRIVACY_POLICY")} <FaChevronRight />
              </Link>
              <button
                onClick={() => {
                  dispatch(userAction("Guest User"));
                  navigate("/home");
                }}
                className="bg-primary  w-[45%] flex items-center justify-center uppercase text-sm lg:text-lg font-normal tracking-[1px] mb-1 px-12 text-white py-2 shadow shadow-slate-400 rounded-sm mt-3"
              >
                {t("SKIP")}
              </button>
            </div>
          </div>
        </div>
      </div>

      <Dialog
        open={openModal}
        onClose={() => setOpenModal(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          id="alert-dialog-title"
          className="flex modal-justify-center flex-col items-center modal-content"
        >
          <FaExclamationTriangle className="text-center text-[3.5rem] text-gray-300 my-3" />
          <p className="text-base mb-0 text-center text-gray-600 font-normal">
            {modalText}
          </p>
        </DialogTitle>
        <DialogActions className="flex modal-justify-center">
          <button
            type="button"
            className="bg-default  uppercase text-xs mt-4 mb-2 px-4 rounded-md text-white py-2 lg:py-1 lg:px-8 lg:text-base shadow shadow-slate-400 "
            onClick={() => setOpenModal(false)}
            autoFocus
          >
            OK
          </button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default LogIn;
